import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "add-ves-event-card__body" }
const _hoisted_2 = { class: "form-grid form-grid--gutter-medium" }
const _hoisted_3 = { class: "form-grid__item form-grid__item--half" }
const _hoisted_4 = { class: "add-ves-event-card__title-row" }
const _hoisted_5 = { class: "form-grid__item form-grid__item--half" }
const _hoisted_6 = { class: "form-grid__item form-grid__item--half" }
const _hoisted_7 = { class: "add-ves-event-card__date-range" }
const _hoisted_8 = { class: "form-grid__item form-grid__item--half" }
const _hoisted_9 = { class: "form-grid__item" }
const _hoisted_10 = { class: "add-ves-event-card__title-row" }
const _hoisted_11 = { class: "form-grid__item" }
const _hoisted_12 = { class: "add-ves-event-card__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComponentInput = _resolveComponent("ComponentInput")!
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!
  const _component_Field = _resolveComponent("Field")!
  const _component_DateComponent = _resolveComponent("DateComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    modelValue: _ctx.localValue,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localValue) = $event)),
    class: "add-ves-event-card",
    width: 720,
    scrollable: "",
    title: _ctx.modalTitle,
    onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('update:modelValue', false))),
    margin: "m-24"
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Field, null, {
              label: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "add-ves-event-card__field-title" }, [
                    _createTextVNode("Страна-партнер "),
                    _createElementVNode("span", { class: "add-ves-event-card__required" }, "*")
                  ], -1)),
                  _createVNode(_component_ComponentInput, {
                    modelValue: _ctx.form.countryPartnerClarified,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.countryPartnerClarified) = $event)),
                    type: "checkbox",
                    mod: "checkbox-green",
                    label: "Уточняется",
                    id: "clarified-country"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_SelectMultiComponent, {
                  modelValue: _ctx.form?.countryPartner ?? [],
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = 
                (val) => {
                  if (_ctx.form) _ctx.form.countryPartner = val;
                  _ctx.clearError('countryPartner');
                }
              ),
                  options: _ctx.mappedCountryOptions,
                  placeholder: "Выберите страну",
                  valueProp: "id",
                  labelOptions: "name",
                  trackBy: "name",
                  mode: "multiple",
                  disabled: _ctx.form?.countryPartnerClarified,
                  canClear: "",
                  canDeselect: "",
                  isError: _ctx.fieldErrors?.countryPartner,
                  textError: _ctx.fieldErrors?.countryPartner ? 'Поле является обязательным для заполнения' : ''
                }, null, 8, ["modelValue", "options", "disabled", "isError", "textError"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Field, {
              label: "Вид мероприятия",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectMultiComponent, {
                  modelValue: _ctx.form.ferEventVedTypeId ?? undefined,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = (val) => (_ctx.form.ferEventVedTypeId = val ?? null)),
                  options: _ctx.eventTypeOptions,
                  placeholder: "Выберите вид",
                  valueProp: "id",
                  labelOptions: "name",
                  mode: "single",
                  isError: _ctx.fieldErrors.ferEventVedTypeId,
                  textError: _ctx.fieldErrors.ferEventVedTypeId ? 'Поле является обязательным для заполнения' : ''
                }, null, 8, ["modelValue", "options", "isError", "textError"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Field, {
              label: "Дата проведения",
              required: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_DateComponent, {
                    modelValue: _ctx.form.startEventDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.startEventDate) = $event)),
                    modClass: "redesigned",
                    placeholder: "дд.мм.гггг",
                    required: "",
                    typeable: "",
                    hasInputMask: "",
                    lowerLimit: _ctx.startDateLowerLimit,
                    class: "date-start",
                    error: _ctx.fieldErrors.startEventDate
                  }, null, 8, ["modelValue", "lowerLimit", "error"]),
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "add-ves-event-card__date-separator" }, "—", -1)),
                  _createVNode(_component_DateComponent, {
                    modelValue: _ctx.form.endEventDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.endEventDate) = $event)),
                    modClass: "redesigned",
                    placeholder: "дд.мм.гггг",
                    typeable: "",
                    hasInputMask: "",
                    lowerLimit: _ctx.endDateLowerLimit,
                    error: _ctx.fieldErrors.endEventDate
                  }, null, 8, ["modelValue", "lowerLimit", "error"])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Field, {
              label: "Статус",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectMultiComponent, {
                  modelValue: _ctx.form.ferEventStatusId ?? undefined,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = (val) => (_ctx.form.ferEventStatusId = val ?? null)),
                  options: _ctx.allowedEventStatusOptions,
                  placeholder: "Выберите статус",
                  valueProp: "id",
                  labelOptions: "name",
                  mode: "single",
                  isError: _ctx.fieldErrors.ferEventStatusId,
                  textError: _ctx.fieldErrors.ferEventStatusId ? 'Поле является обязательным для заполнения' : ''
                }, null, 8, ["modelValue", "options", "isError", "textError"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Field, null, {
              label: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "add-ves-event-card__field-title" }, [
                    _createTextVNode("Место "),
                    _createElementVNode("span", { class: "add-ves-event-card__required" }, "*")
                  ], -1)),
                  _createVNode(_component_ComponentInput, {
                    modelValue: _ctx.form.eventLocationClarified,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.eventLocationClarified) = $event)),
                    type: "checkbox",
                    mod: "checkbox-green",
                    label: "Уточняется",
                    id: "clarified-location"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.form.eventLocation,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.eventLocation) = $event)),
                  type: "textarea",
                  mod: "rectangular",
                  placeholder: "Введите место",
                  disabled: _ctx.form.eventLocationClarified,
                  maxLength: 1000,
                  required: !_ctx.form.eventLocationClarified,
                  textareaStyles: { minHeight: '80px' }
                }, null, 8, ["modelValue", "disabled", "required"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Field, {
              label: "Наименование",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "textarea",
                  mod: "rectangular",
                  placeholder: "Введите наименование",
                  maxLength: 1000,
                  required: "",
                  textareaStyles: { minHeight: '80px' }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ])
      ])), [
        [_directive_loading, _ctx.isLoadingData]
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_ButtonComponent, {
          mod: "white",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createTextVNode("Отмена", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_ButtonComponent, {
          mod: "gradient-bg",
          onClick: _ctx.onSubmit,
          disabled: _ctx.isSaving
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createTextVNode("Сохранить", -1)
          ]))]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}